'use es6';

import { LAYOUT_GROUPING_TOGGLE, LAYOUT_GROUPING_CREATE, LAYOUT_GROUPING_TOGGLE_WIDGET, LAYOUT_GROUPING_VALIDATED, LAYOUT_GROUPING_REMOVE } from 'DesignData/actions/ActionTypes';
import { getBuiltinByType } from 'DesignData/selectors/layoutWidgets';
import { validate } from 'DesignData/lib/layouts/widgets/grouping';
import ValidatedLayoutGroup from 'DesignData/models/layouts/layoutGrouping/ValidatedLayoutGroup';

function createGroupRequest(layoutId, groupingMatrix, cell) {
  return {
    type: LAYOUT_GROUPING_CREATE,
    layoutId,
    groupingMatrix,
    cell
  };
}
/**
 * Turn grouping mode on/off.
 */


export function toggleGrouping(layoutId) {
  return {
    type: LAYOUT_GROUPING_TOGGLE,
    layoutId
  };
}
/**
 * Create group from selected widgets.
 *
 * @param {Number}          layoutId
 */

export function createGroup(layoutId) {
  const {
    request
  } = createGroup;
  return (dispatch, getState) => {
    const state = getState();
    const {
      groupingMatrix,
      isValid
    } = state.layoutGrouping.byId[layoutId];

    if (!isValid) {
      return;
    }

    const cell = getBuiltinByType(state, 'cell');
    dispatch(request(layoutId, groupingMatrix, cell));
  };
}
createGroup.request = createGroupRequest;
/**
 * Creates group from passed widget list.
 *
 * @param {Number}          layoutId
 * @param {Array.<String>}  widgetList  List of widget ids.
 */

export function createGroupFromWidgets(layoutId, widgetList) {
  const {
    request
  } = createGroupFromWidgets;
  return (dispatch, getState) => {
    const state = getState();
    const validatedLayoutGroup = validate(state, layoutId, widgetList);
    const {
      groupingMatrix,
      isValid
    } = validatedLayoutGroup;

    if (!isValid) {
      return;
    }

    const cell = getBuiltinByType(state, 'cell');
    dispatch(request(layoutId, groupingMatrix, cell));
  };
}
createGroupFromWidgets.request = createGroupRequest;
/**
 * Select/Deselect a widget for grouping.
 */

export function toggleWidget(layoutId, widgetId, rowId, parentId) {
  return {
    type: LAYOUT_GROUPING_TOGGLE_WIDGET,
    layoutId,
    widgetId,
    rowId,
    parentId
  };
}
/**
 * Pass grouping validation status.
 */

export function validated(layoutId, validatedLayoutGroup) {
  if (!(validatedLayoutGroup instanceof ValidatedLayoutGroup)) {
    throw new TypeError(`Expected 'ValidatedLayoutGroup' instance, received ${validatedLayoutGroup}`);
  }

  return {
    type: LAYOUT_GROUPING_VALIDATED,
    layoutId,
    validatedLayoutGroup
  };
}
/**
 * Remove/clear grouping data for layout.
 */

export function remove(layoutId) {
  return {
    type: LAYOUT_GROUPING_REMOVE,
    layoutId
  };
}